function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgViewportWindowLevel = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 19,
  height: 19,
  style: {
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  },
  viewBox: "0 0 833.33 833.33",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "m4.71 692.68 399.09.16c8.44-53.91-5.39-71.49 17.49-128.79 74.19-185.8 252.39-161.08 281.59-168.36l.41-394.8c-14.71 4.33-154.14 148.24-176.35 170.13-59.62 58.74-115.6 114.93-175.19 173.56L90.06 603.87c-16.28 16.2-80.39 73.09-85.35 88.81m647.16-82.75c62.5-23.24 98.68 75.87 32.09 97.2-63.47 20.33-101.8-71.28-32.09-97.2m-23.33-125c-13.16 19.33.45 86.51-67.72 58.49-28.9-11.87-30.67.16-42.2 20.89-7.63 13.71-19.72 28.2-21.52 46.98 14.57 8.15 24.38 18.45 38.65 27.35 1.98 57.02-10.97 37.18-37.47 68.03 1.12 15.81 26.47 58.66 37.4 70.96 31.6-.03 38.62-23.82 64.22-9.42 32.74 18.41 11.38 33.79 28.04 60.46 15.18 6.96 63.27 8.09 80.79-.72 14.81-31.17-6.26-43.89 28.16-60.33 21.39-10.22 34.39 6.7 60.5 11.29 13.72-13.39 33.97-47.76 40.66-68.06-13.51-23.99-38.67-20.5-39.78-50.3-1.26-33.89 22.08-29.01 39.32-54.25-7.26-24.48-25.02-45.11-34.95-67.42-37.41-2.49-38.48 24.39-70.04 6.43-24.51-13.95-13.5-17.84-23.57-61.65l-80.48 1.28z",
  style: {
    fill: "currentColor"
  }
}));
export { SvgViewportWindowLevel as ReactComponent };
export default __webpack_public_path__ + "assets/images/viewport-window-level.svg";